import classNames from 'classnames'
import React from 'react'

import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { LayoutLogin as CoreLayoutLogin } from 'src/core/layout/Login'

import styles from './Login.module.scss'

const LOGO_URL =
  'https://res.cloudinary.com/appbuilder/image/upload/v1694101920/Images/aria/aria__logo--white.svg'

export const LayoutLogin = () => {
  return (
    <CoreLayoutLogin
      content={({ onSubmit, progress }) => {
        return (
          <div className={styles.root}>
            <div className={styles.centering}>
              <div className={styles.content}>
                <img className={styles.logo} src={LOGO_URL} alt="ARIA" />
                <div className={styles.paper}>
                  <p className={styles.paper__title}>Login</p>
                  <div className={styles.form}>
                    <Button
                      disabled={progress}
                      id={'LOGIN_BUTTON'}
                      className={classNames(
                        styles.submit,
                        progress ? styles['submit--loading'] : ''
                      )}
                      onClick={onSubmit}
                    >
                      {progress ? (
                        <Loader dimension={{ width: 24, height: 24 }} />
                      ) : (
                        'Sign In with HP ID'
                      )}
                    </Button>
                  </div>

                  <p className={styles.note}>
                    If you are having trouble signing in,
                    <br />
                    please contact support.
                    <br />
                    <a href="mailto:ARIASupport@hp.com" className={styles.note__link}>
                      Email support
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}
